import { lightRed, orange } from 'styles'

import { makeStyles } from '@mui/styles'

interface ThemeProps {
  isValidDate: boolean
}

export default makeStyles({
  calendarIcon: {
    fontSize: '1.5rem',
    padding: '0.25rem',
    color: ({ isValidDate }: ThemeProps) => (isValidDate ? orange : lightRed),
  },
})
